import React, { useContext } from 'react';
import { ModalContext } from 'App';
// import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import VerifyConfirmationModal from '../modals/VerifyConfirmationModal';

const useVerifyConfirmation = (
  isLoading,
  isStartAssessment,
  refreshList,
  transactionStatus,
  id,
  trackingNo,
  transactionType,
) => {
  const setModal = useContext(ModalContext);
  const isAllowed = true;

  const isStatusAllowed = ['ONGOING'].indexOf(transactionStatus) > -1;

  const showComponent =
    isAllowed && isStartAssessment && isStatusAllowed;


  const onHandleClick = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <VerifyConfirmationModal id={id} trackingNo={trackingNo} refreshList={refreshList} transactionType={transactionType} />,
      title: `Verify Application`,
      modalSize: 'modal-md',
    });
  };

  const component = showComponent ? (
    <div className="mx-2 mb-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Verify
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useVerifyConfirmation;
